module.exports = __webpack_public_path__ + "static/6-e7809c8d9e7309114926a07427b42735.svg";